module.exports = __webpack_public_path__ + "static/media/calculator.74c684b1.png";